import React, { useState, createContext, useContext, useEffect } from 'react';

const layoutConfig = {
  headerActive: false,
  headerVariant: 'dark',
  headerCollapse: 'lg',
  headerFixed: false,
  sideBarActive: false,
  breaks: {
    mb: 420,
     sm: 576,
      md: 768,
       lg: 992,
        xl: 1200,
         xxl: 1540,
          any: Infinity
  },
  headerLogos: {
    "/": "s1.dark",
    "/404": "s1.dark",
    "/blogs": "s1.dark",
    "/how-it-works": "s1.dark",
    "/about-weathersafe": "s1.dark",
    "/about-gap-77": "s1.dark",
    "/farm-maps": "s1.dark",
    "/structure": "s1.dark",
    "/achievable-goals": "s1.dark",
    "/blog-details": "s1.dark",
    "/terms-and-conditions": "s1.dark",
    "/national-coffee-census": "s1.dark",
    "/contact-us-solution": "s1.dark",
  },
  footerLogos: {
    "/": "s1.light",
    "/404": "s1.dark",
    "/blogs": "s1.dark",
    "/how-it-works": "s1.dark",
    "/about-weathersafe": "s1.dark",
    "/about-gap-77": "s1.dark",
    "/farm-maps": "s1.dark",
    "/structure": "s1.dark",
    "/achievable-goals": "s1.dark",
    "/blog-details": "s1.dark",
    "/terms-and-conditions": "s1.dark",
    "/national-coffee-census": "s2.dark",
    "/contact-us-solution": "s2.dark",
  }
}

// create context
const LayoutContext = createContext();
const LayoutUpdateContext = createContext();

export function useLayout() {
  return useContext(LayoutContext);
}

export function useLayoutUpdate() {
  return useContext(LayoutUpdateContext);
}

export default function LayoutProvider({ children }) {
  const storedRTL = localStorage.getItem('isRTL');
  const [layout, setLayout] = useState({
    ...layoutConfig,
    isRTL: storedRTL ? JSON.parse(storedRTL) : false
  });

  const updateLayout = {
    headerMobile: function () {
      const newLayout = {
        ...layout,
        headerActive: !layout.headerActive,
        headerFixed: !layout.headerFixed
      }
      setLayout(newLayout);
    },

    sideBarAction: function () { 
      const newLayout = { 
        ...layout,
        sideBarActive: !layout.sideBarActive,
      }
      setLayout(newLayout);
    },

    toggleRTL: function () { // Function to toggle RTL
      const newRTL = !layout.isRTL;
      setLayout({ ...layout, isRTL: newRTL });
      localStorage.setItem('isRTL', JSON.stringify(newRTL)); // Store RTL value in local storage
    }
  }

  useEffect(() => {
    // Update HTML attribute 'dir' based on RTL state
    document.documentElement.setAttribute('dir', layout.isRTL ? 'rtl' : 'ltr');
  }, [layout.isRTL]);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      const headerBreak = layout.breaks[layout.headerCollapse];

      if (width > headerBreak && layout.sideBarActive) {
        const newLayout = { ...layout, sideBarActive: false };
        setLayout(newLayout);
      }
    });

    observer.observe(document.body);

    return () => {
      observer.disconnect();
    };
  }, [layout]);

  return (
    <LayoutContext.Provider value={layout}>
      <LayoutUpdateContext.Provider value={updateLayout}>
        {children}
      </LayoutUpdateContext.Provider>
    </LayoutContext.Provider>
  )
}
